import { render, staticRenderFns } from "./lingwing-password-change.vue?vue&type=template&id=6419fd94&scoped=true"
import script from "./lingwing-password-change.vue?vue&type=script&lang=js"
export * from "./lingwing-password-change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6419fd94",
  null
  
)

export default component.exports